import { createSelector } from 'reselect';
import { JOB_STATUSES } from 'lib/constants';
import { getOffline } from './getOffline';
import { getIsAgentConnected } from './getIsAgentConnected';
import { getUnavailableStartAt } from './getUnavailableStartAt';
import { getFaultStartAt } from './getFaultStartAt';
import { getStatusLabel } from './getStatusLabel';
import { getIsPaused } from './getIsPaused';
import { getJobStatus } from './getJobStatus';

export const getMachineHeaderVariant = createSelector(
  [
    getOffline,
    getIsAgentConnected,
    getUnavailableStartAt,
    getFaultStartAt,
    getStatusLabel,
    getIsPaused,
    getJobStatus,
  ],
  (
    offline,
    isAgentConnected,
    unavailableStartAt,
    faultStartAt,
    status,
    isPaused,
    jobStatus
  ) => {
    const fault = !!faultStartAt;

    if (offline || !isAgentConnected || unavailableStartAt) {
      return 'unavailable';
    }
    if (isPaused) {
      return 'pause';
    }
    if (jobStatus === JOB_STATUSES.SETUP) {
      return 'setup';
    }
    if (fault) {
      return 'fault';
    }
    return status;
  }
);
